module.exports = __webpack_public_path__ + "static/img/4.0580dd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/eng/4.png
// module id = giMq
// module chunks = 0